import React from 'react';
import { Protect } from '@clerk/clerk-react';
import { Icon } from '@nearst/ui';
import plurify from '@utils/plurify';
import { useIsChain } from '@utils/useIsChain';

import styles from './InventoryViewer.module.scss';

export const SelectedBarcodesActionBar = ({ selectedBarcodes, setEditChannelsModalShown, markHidden, hideMode }) => {
	const isChain = useIsChain();

	if (!selectedBarcodes.length) return null;

	return (
		<div className={styles.actionBar}>
			<span className={styles.barcodeSelected}>
				{selectedBarcodes.length} {plurify('barcode', selectedBarcodes.length)} selected
			</span>
			<Protect condition={(has) => has({ permission: 'org:channels:manage' }) || has({ permission: 'org:inventory:hide' })}>
				<span className={styles.actionsDivider}>|</span>
			</Protect>
			{!isChain && (
				<Protect permission="org:channels:manage">
					<button className={styles.actionButton} onClick={() => setEditChannelsModalShown(true)}>
						<Icon>settings</Icon>Edit channels
					</button>
				</Protect>
			)}
			<Protect permission="org:inventory:hide">
				{/* Single store mode shows toggle button */}
				{!isChain && (
					<button className={styles.actionButton} onClick={() => markHidden(!hideMode)}>
						{hideMode ? (
							<>
								<Icon>visibility_off</Icon> Mark as hidden
							</>
						) : (
							<>
								<Icon>visibility</Icon> Mark as visible
							</>
						)}
					</button>
				)}

				{/* Chain mode shows both buttons */}
				{isChain && (
					<>
						<button className={styles.actionButton} onClick={() => markHidden(false)}>
							<Icon>visibility_off</Icon> Mark as hidden
						</button>
						<button className={styles.actionButton} onClick={() => markHidden(true)}>
							<Icon>visibility</Icon> Mark as visible
						</button>
					</>
				)}
			</Protect>
		</div>
	);
};
